import React, { useState } from "react";
import Papa from "papaparse";
import useApi from "../../utils/useApi";

const ContactCsvUploader = () => {
  const { Post } = useApi();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: async ({ data }) => {
        setLogs([]);
        setLoading(true);

        for (const row of data) {
          const log = await uploadRow(row);
          setLogs((prev) => [...prev, log]);
        }

        setLoading(false);
      },
    });
  };

  const uploadRow = async (row) => {
    const payload = {
      group_title: row["ACTP"],
      subscription_no: parseInt(row["ACNO"]),
      full_name: row["NAME2"],
      phone_no: row["PHONE"],
      address: row["ADDR"],
    };

    try {
      const res = await Post("updateUserInfoInSubscription", payload);

      if (res.status != 200) {
        const error = await res.json();
        return `❌ ${row["ACNO"]} - ${error.detail || JSON.stringify(error)}`;
      }

      return `✅ Updated subscription #${row["ACNO"]} in group ${row["ACTP"]}`;
    } catch (err) {
      return `❌ ${row["ACNO"]} - ${err.message}`;
    }
  };

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold mb-4">Update Contacts via CSV</h2>
      <input
        type="file"
        accept=".csv"
        onChange={handleFileChange}
        className="mb-4"
      />
      {loading && <p className="text-blue-600">⏳ Processing...</p>}
      <ul className="mt-4 space-y-2 text-sm">
        {logs.map((log, idx) => (
          <li key={idx}>{log}</li>
        ))}
      </ul>
    </div>
  );
};

export default ContactCsvUploader;
